module.exports = __webpack_public_path__ + "static/fonts/ProximaNova-Regular.410504d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Regular.otf
// module id = HJq+
// module chunks = 1